import { Component, OnInit } from '@angular/core';
import { ManageService } from '../service/manage.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-manage-system-message',
    templateUrl: './manage-system-message.component.html',
    styleUrl: './manage-system-message.component.css',
    standalone: false
})
export class ManageSystemMessageComponent implements OnInit{
  public isMaintenanceMessageActive: boolean = false;
  public isActiveMaintenanceMessageActive: boolean = false;
  public isSetMaintModeActive: boolean = false;

  constructor(
    public manageService: ManageService
  ){}

  async ngOnInit(){
    this.setActiveButtonToFalse();
    this.activeMaintenanceMessageClicked();

    this.manageService.maintenanceMessageSaved$.subscribe(async () => {
      this.activeMaintenanceMessageClicked();
    });

    this.manageService.maintenanceMessageCreated$.subscribe(async () => {
      this.maintenanceMessageclicked();
    });
  }

  // Function called to reset all UI boolean variable to false
  setActiveButtonToFalse(){
    this.isMaintenanceMessageActive = false;
    this.isActiveMaintenanceMessageActive = false;
    this.isSetMaintModeActive = false;
    this.manageService.showManageModal = false;
  }

  // Function called to show maintenance message list
  async maintenanceMessageclicked(){
    this.setActiveButtonToFalse();

    await this.manageService.getMaintenanceMessageList();

    // Set UI variable at true
    this.isMaintenanceMessageActive = true;
  }

  // Function called to show active maintenance messages
  async activeMaintenanceMessageClicked(){
    this.setActiveButtonToFalse();
    this.manageService.activeMaintenanceMessageArray = (await firstValueFrom(this.manageService.getActiveMaintenanceMessage())).map(item => ({
      ...item,
      message_fr: this.manageService.decodeHtml(item.message_fr),
      message_en: this.manageService.decodeHtml(item.message_en)
    }));
    // Set UI variable at true
    this.isActiveMaintenanceMessageActive = true;
  }

  // Function called to show create maintenance message
  createMaintenanceMessageClicked(){
    // Set UI variabe at true
    this.manageService.openCreateMaintenanceMessage();
  }

  // Function used to open te maint mode page
  maintModeClicked(){
    this.setActiveButtonToFalse();
    this.isSetMaintModeActive = true;

    this.manageService.getServersStatusInfo().subscribe((response) => {
      this.manageService.serversInfoList = JSON.parse(JSON.stringify(response.data));
    });
  }

  selectAllServerChange(event: Event): void{
    const checked = (event.target as HTMLInputElement).checked;
    const enabledServers = this.manageService.serversInfoList
      .filter(server => server.maint_mode === 1)
      .map(server => server.name);

    if(checked){
      this.manageService.selectedServers = [...enabledServers];
    }else{
      this.manageService.selectedServers = [];
    }
  }

  removeMaintMode(){
    console.log(this.manageService.selectedServers);
  }

  serverChecked(serverName: string, event: Event){
    const checked = (event.target as HTMLInputElement).checked;
    const server = this.manageService.serversInfoList.find(server => server.name === serverName);

    if(!server || server.maint_mode !== 1){
      return;
    }

    const selected = this.manageService.selectedServers;

    if(checked){
      if(!selected.includes(serverName)){
        selected.push(serverName);
      }
    }else{
      const index = selected.indexOf(serverName);
      if(index !== 1){
        selected.splice(index, 1);
      }
    }
  }

  isServerSelected(serverName: string): boolean{
    return this.manageService.selectedServers.includes(serverName);
  }

  isAllSelected(){
    const selectedServers = this.manageService.serversInfoList
      .filter(server => server.maint_mode === 1)
      .map(server => server.name);

    return (
      selectedServers.length > 0 &&
      selectedServers.every(name =>
        this.manageService.selectedServers.includes(name)
      )
    );
  }
}
